export default {
  formId: "user-form",
  formField: {
    organization: {
      name: "organization",
      label: "Organization",
      type: "select",
      size: "large",
      isMulti: false,
      placeholder: "Select an organization",
      errorMsg: "Organization is required.",
    },
    subOrganization: {
      name: "subOrganization",
      label: "Sub Organization",
      type: "select",
      size: "large",
      isMulti: false,
      placeholder: "Select a sub organization",
      errorMsg: "Sub Organization is required.",
    },
    classData: {
      name: "classData",
      label: "Class",
      type: "select",
      size: "large",
      isMulti: true,
      placeholder: "Select a class",
      errorMsg: "Class is required.",
    },
    email: {
      name: "email",
      label: "Email",
      type: "text",
      size: "large",
      placeholder: "Enter an email",
      errorMsg: "Email is required.",
    },
    userType: {
      name: "userType",
      label: "User Type",
      type: "select",
      size: "large",
      isMulti: false,
      placeholder: "Select a user type",
      errorMsg: "User Type is required.",
    },
    name: {
      name: "name",
      label: "Name",
      type: "text",
      size: "large",
      placeholder: "Enter a name",
      errorMsg: "Name is required.",
    },
    surname: {
      name: "surname",
      label: "Surname",
      type: "text",
      size: "large",
      placeholder: "Enter a surname",
      errorMsg: "Surname is required.",
    },
    nickName: {
      name: "nickName",
      label: "Nick Name",
      type: "text",
      size: "large",
      placeholder: "Enter a nick name",
      errorMsg: "Nick Name is required.",
    },
    studentNo: {
      name: "studentNo",
      label: "Student No",
      type: "text",
      size: "large",
      placeholder: "Enter a student no",
      errorMsg: "Student No is required.",
    },
    allBooksEnabled: {
      name: "allBooksEnabled",
      label: "All Books Enabled",
      type: "switch",
      size: "large",
    },
  },
};
